import { CreateProductCategoryRequest } from '../dto/CreateProductCategoryRequest';
import { PagedResponse } from '../dto/PagedResponse';
import { ProductCategoryDto } from '../dto/ProductCategoryDto.dto';
import { UpdateProductCategoryRequest } from '../dto/UpdateProductCategoryRequest';
import { ListParams } from '../http/ListParams';
import { QueryBuilder } from '../http/QueryBuilder';
import { JsonRequestBody } from '../http/JsonRequestBody';

import {
    IProductCategoryMapper,
    ProductCategoryMapper,
} from '../mapper';

import { IProductCategoryService } from './IProductCategoryService';
import { ProductCategoryEndpoints } from './ProductCategoryEndpoints';

// @ts-ignore
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';

export class ProductCategoryService implements IProductCategoryService {
    constructor(
        private readonly mapper: IProductCategoryMapper =
            new ProductCategoryMapper(),
    ) {}

    async getList(
        params?: ListParams,
    ): Promise<PagedResponse<ProductCategoryDto>> {
        const response = await fetchWithAuth(
            ProductCategoryEndpoints.list(
                QueryBuilder.from(params).build(),
            ),
            {
                method: 'GET',
            },
        );

        return this.mapper.toPagedResponse(response);
    }

    async getById(
        externalId: string,
    ): Promise<ProductCategoryDto> {
        const response = await fetchWithAuth(
            ProductCategoryEndpoints.get(externalId),
            {
                method: 'GET',
            },
        );

        return this.mapper.toDto(response);
    }

    async create(
        request: CreateProductCategoryRequest,
    ): Promise<ProductCategoryDto> {
        const response = await fetchWithAuth(
            ProductCategoryEndpoints.create(),
            {
                method: 'POST',
                ...JsonRequestBody.from(
                    this.mapper.toApiPayload(request),
                ),
            },
        );

        return this.mapper.toDto(response);
    }

    async update(
        externalId: string,
        request: UpdateProductCategoryRequest,
    ): Promise<ProductCategoryDto> {
        const response = await fetchWithAuth(
            ProductCategoryEndpoints.update(externalId),
            {
                method: 'PATCH',
                ...JsonRequestBody.from(
                    this.mapper.toApiPayload(request),
                ),
            },
        );

        return this.mapper.toDto(response);
    }

    async activate(
        externalId: string,
    ): Promise<void> {
        return fetchWithAuth(
            ProductCategoryEndpoints.activate(externalId),
            {
                method: 'PUT',
            },
        );
    }

    async deactivate(
        externalId: string,
    ): Promise<void> {
        return fetchWithAuth(
            ProductCategoryEndpoints.deactivate(externalId),
            {
                method: 'PUT',
            },
        );
    }

    async delete(
        externalId: string,
    ): Promise<void> {
        return fetchWithAuth(
            ProductCategoryEndpoints.delete(externalId),
            {
                method: 'DELETE',
            },
        );
    }
}

const productCategoryService =
    new ProductCategoryService();

export default productCategoryService;